import { Drawer, Modal } from "@mantine/core";
import { useState }      from "react";

import { useGetCreatorPlusStatus } from "_common/hooks/auth";
import { useGetDeviceType }        from "_common/hooks/global";
import { useOpenCreatorPlusModal } from "_common/hooks/useOpenCreatorPlusModal";
import { useAddQueryParam }        from "_common/hooks/useQueryParams";
import PrimaryButton               from "_components/atoms/button/primaryButton";
import Icon                        from "_components/atoms/icon";
import Image                       from "_components/atoms/image";
import Typography                  from "_components/atoms/typography";

import StreamList from "./expiringList";
import useStyles  from "./styles";

const component = ( {
	activeTab,
	deletionTime,
	isDepleted,
	isLoading,
	list = [],
	fetchMore,
	updateDeletedPost,
	uploadType,
	streamsToDelete = [],
	totalNoOfStreams = 0
} ) => {

	const [ streamModal, setStreamModal ] = useState ( false );

	const isCreatorPlus        = useGetCreatorPlusStatus ();
	const openCreatorPlusModal = useOpenCreatorPlusModal ();
	const addQueryParam        = useAddQueryParam ();
	const { classes }          = useStyles ();
	const deviceType           = useGetDeviceType ();
	const isMobile             = deviceType === "mobile";

	function handleOpenCreatorPlusModal () {
		if ( isCreatorPlus ) {
			addQueryParam ( { alreadyPlus: "true" } );

			return;
		}

		openCreatorPlusModal ();
	}

	// Calculate days until deletion
	const getDaysUntilDeletion = () => {
		if ( !deletionTime )
			return ""; // Default to 7 days if deletionTime is not available

		const deletionDate = new Date ( deletionTime );
		const now          = new Date ();
		const diffTime     = deletionDate - now;
		const diffDays     = Math.ceil ( diffTime / ( 1000 * 60 * 60 * 24 ) );

		if ( diffDays <= 0 )
			return "today";
		if ( diffDays === 1 )
			return "tomorrow";

		return `${ diffDays } Days`;
	};

	const daysUntilDeletion = getDaysUntilDeletion ();

	// Get first three streams for thumbnail display
	const firstThreeStreams = streamsToDelete.slice ( 0, 3 );

	return (
		<div className = { classes.container }>
			<div className = { classes.thumbnailStack }>
				{firstThreeStreams[2] && (
					<Image
						className   = { classes.third }
						lazy        = { false }
						placeholder = "/images/thumbnail_placeholder.webp"
						src         = { firstThreeStreams[2].thumbnail }
						width       = "100%"
					/>
				)}

				{firstThreeStreams[1] && (
					<Image
						className   = { classes.second }
						lazy        = { false }
						placeholder = "/images/thumbnail_placeholder.webp"
						src         = { firstThreeStreams[1].thumbnail }
						width       = "100%"
					/>
				)}

				{firstThreeStreams[0] && (
					<Image
						className   = { classes.first }
						lazy        = { false }
						placeholder = "/images/thumbnail_placeholder.webp"
						src         = { firstThreeStreams[0].thumbnail }
						width       = "100%"
					/>
				)}
			</div>

			<div className = { classes.content }>
				<div className = { classes.noticeText }>
					<div
						className = { classes.titleWithIcon }
						onClick   = { () => {
							setStreamModal ( true );
						} }
					>
						<Typography className = { classes.strong }
							title                = { `${ totalNoOfStreams } Streams Deleting ${ daysUntilDeletion === "today" ? "Today" : daysUntilDeletion === "tomorrow" ? "Tomorrow" : `in ${ daysUntilDeletion }` }` }
						/>

						<Icon
							name = { "arrowForward" }
							size = { "2rem" }
						/>
					</div>

					<Typography className  = { classes.paragraph }
						title                 = { "Upgrade to Creator Plus and Save Your Favorite Streams from Getting Deleted" }
					/>
				</div>

				<PrimaryButton className                     = { classes.button }
					onClick                                     = { handleOpenCreatorPlusModal }
					title                                       = "Upgrade to Creator Plus"
				/>

			</div>

			{isMobile ? (
				<Drawer
					classNames      = { {
						body    : classes.drawerBody,
						content : classes.drawerContent
					} }
					onClose         = { () => {
						setStreamModal ( false );
					} }
					opened          = { streamModal }
					position        = { "bottom" }
					withCloseButton = { false }
					zIndex          = { 1200 }
				>
					<StreamList
						deletionTime     = { deletionTime }
						onClose          = { () => {
							setStreamModal ( false );
						} }
						streamsToDelete  = { streamsToDelete }
						totalNoOfStreams = { totalNoOfStreams }
					/>
				</Drawer>
			) : (
				<Modal
					centered
					classNames      = { {
						body    : classes.modalBody,
						content : classes.modalContent,
						root    : classes.modalRoot
					} }
					onClose         = { () => {
						setStreamModal ( false );
					} }
					opened          = { streamModal }
					withCloseButton = { false }
					zIndex          = { 1200 }
				>
					<StreamList
						deletionTime     = { deletionTime }
						onClose          = { () => {
							setStreamModal ( false );
						} }
						streamsToDelete  = { streamsToDelete }
						totalNoOfStreams = { totalNoOfStreams }
					/>
				</Modal>
			)}
		</div>
	);
};

export default component;